import React, { useMemo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CampaignButtonVariant } from "../../../components/common/Button/Button";
import CampaignCard from "../../../components/common/CampaignCard/CampaignCard";
import CampaignCardSkeleton from "../../../components/common/CampaignCard/CampaignCardSkeleton";
import SectionHeader from "../../../components/common/SectionHeader";
import { getCategorySection } from "../../../api/services/campaignService";
import { Images } from "../../../utils/Images";

// ─── Category SVG Icons (Figma-exact paths) ───────────────────────────────────
const CategoryIcons = {
  Urgent: ({ color }) => (
    <svg width="18" height="18" viewBox="49.9 32.2 16.2 16.1" fill="none">
      <path d="M63.0915 45.3232V40.2323C63.0915 37.4251 60.8074 35.1414 58.0006 35.1414C55.1938 35.1414 52.9096 37.4251 52.9096 40.2323V45.3232C52.1078 45.3232 51.4551 45.9755 51.4551 46.7777V47.8686C51.4551 48.0696 51.6177 48.2323 51.8187 48.2323H64.1824C64.3834 48.2323 64.546 48.0696 64.546 47.8686V46.7777C64.546 45.9755 63.8933 45.3232 63.0915 45.3232ZM53.6369 40.2323C53.6369 37.826 55.5943 35.8686 58.0006 35.8686C60.4068 35.8686 62.3642 37.826 62.3642 40.2323V45.3232H53.6369V40.2323ZM63.8187 47.505H52.1824V46.7777C52.1824 46.3768 52.5084 46.0505 52.9096 46.0505H63.0915C63.4928 46.0505 63.8187 46.3768 63.8187 46.7777V47.505Z" fill={color}/>
      <path d="M58.0004 34.414C58.2014 34.414 58.364 34.2514 58.364 34.0504V32.5958C58.364 32.3948 58.2013 32.2322 58.0004 32.2322C57.7994 32.2322 57.6367 32.3948 57.6367 32.5958V34.0504C57.6367 34.2514 57.7994 34.414 58.0004 34.414Z" fill={color}/>
      <path d="M61.6361 34.7779C61.7291 34.7779 61.8222 34.7424 61.8932 34.6714L62.9848 33.5805C63.1269 33.4388 63.1269 33.2083 62.9848 33.0663C62.8428 32.9242 62.6127 32.9242 62.4706 33.0663L61.379 34.1572C61.2369 34.2989 61.2369 34.5293 61.379 34.6714C61.45 34.7424 61.543 34.7779 61.6361 34.7779Z" fill={color}/>
      <path d="M54.1059 34.6714C54.1769 34.7424 54.27 34.7779 54.363 34.7779C54.456 34.7779 54.5491 34.7424 54.6201 34.6714C54.7622 34.5297 54.7622 34.2992 54.6201 34.1572L53.5299 33.0663C53.3879 32.9242 53.1577 32.9242 53.0157 33.0663C52.8737 33.2079 52.8737 33.4384 53.0157 33.5805L54.1059 34.6714Z" fill={color}/>
      <path d="M65.9618 36.4333C65.8716 36.2536 65.6543 36.1819 65.4739 36.2707L64.0193 36.9979C63.8396 37.0878 63.7672 37.3062 63.8567 37.4859C63.9206 37.6134 64.0492 37.6869 64.182 37.6869C64.2367 37.6869 64.2921 37.6744 64.3446 37.6485L65.7992 36.9213C65.9789 36.8314 66.0513 36.613 65.9618 36.4333Z" fill={color}/>
      <path d="M51.8182 37.6866C51.951 37.6866 52.0796 37.6131 52.1435 37.4856C52.233 37.3059 52.1605 37.0875 51.9808 36.9976L50.5263 36.2704C50.3466 36.1823 50.1285 36.2533 50.0383 36.433C49.9488 36.6127 50.0213 36.8311 50.201 36.921L51.6555 37.6482C51.7081 37.6741 51.7635 37.6866 51.8182 37.6866Z" fill={color}/>
      <path d="M57.9997 36.5959C55.9947 36.5959 54.3633 38.2273 54.3633 40.2323C54.3633 40.4333 54.5259 40.596 54.7269 40.596C54.9279 40.596 55.0906 40.4333 55.0906 40.2323C55.0906 38.6283 56.3953 37.3232 57.9997 37.3232C58.2007 37.3232 58.3633 37.1606 58.3633 36.9596C58.3633 36.7586 58.2006 36.5959 57.9997 36.5959Z" fill={color}/>
    </svg>
  ),
  Children: ({ color }) => (
    <svg width="18" height="18" viewBox="153 31.5 18.2 17.1" fill="none">
      <path d="M162.091 48.4822C159.482 48.4822 157.105 47.1629 155.727 44.9534C155.719 44.9429 155.711 44.9324 155.705 44.9227C155.535 44.6489 155.378 44.3489 155.224 44.0084C154.803 43.0432 154.591 42.0269 154.591 40.9822C154.58 40.9349 154.216 38.4982 154.216 37.2322C154.216 33.6119 157.434 33.1687 158.186 33.1147C158.587 32.7569 160.039 31.6072 162.091 31.6072C165.361 31.6072 169.966 33.3524 169.966 37.2322C169.966 38.4749 169.602 40.9334 169.587 41.0369C169.591 42.0232 169.379 43.0424 168.961 44.0107C168.794 44.3789 168.611 44.7157 168.413 45.0194C168.399 45.0412 168.383 45.0622 168.364 45.0802C167.029 47.1892 164.668 48.4822 162.091 48.4822ZM156.328 44.5042C156.336 44.5147 156.344 44.5244 156.35 44.5349C157.588 46.5367 159.734 47.7322 162.091 47.7322C164.41 47.7322 166.535 46.5689 167.774 44.6212C167.789 44.5987 167.806 44.5762 167.825 44.5574C167.96 44.3392 168.125 44.0354 168.275 43.7069C168.65 42.8399 168.841 41.9204 168.841 40.9822C168.848 40.9027 169.216 38.4202 169.216 37.2322C169.216 33.8699 165.05 32.3572 162.091 32.3572C160.02 32.3572 158.62 33.7334 158.606 33.7477C158.536 33.8174 158.441 33.8564 158.342 33.8572C158.204 33.8579 154.966 33.9097 154.966 37.2322C154.966 38.4427 155.333 40.9019 155.337 40.9267C155.341 41.9227 155.532 42.8392 155.91 43.7047C156.043 44.0017 156.181 44.2649 156.328 44.5042Z" fill={color} stroke={color} strokeWidth="0.2"/>
      <path d="M169.057 42.8572C168.894 42.8572 168.744 42.75 168.697 42.5857L167.808 39.4807C162.382 39.4357 160.185 38.0842 159.31 37.14C158.744 38.595 157.011 39.2295 156.393 39.4132L155.485 42.585C155.428 42.7852 155.22 42.9007 155.022 42.8422C154.823 42.7852 154.708 42.5775 154.765 42.3787L155.731 39.0037C155.767 38.8732 155.873 38.7727 156.005 38.742C156.033 38.7352 158.742 38.0737 158.742 36.1515C158.742 35.9617 158.884 35.802 159.072 35.7795C159.261 35.7517 159.436 35.8777 159.481 36.0622C159.487 36.0825 160.335 38.7322 168.091 38.7322C168.258 38.7322 168.405 38.8425 168.451 39.0037L169.417 42.3787C169.474 42.5782 169.358 42.7852 169.159 42.8422C169.126 42.8527 169.09 42.8572 169.057 42.8572Z" fill={color} stroke={color} strokeWidth="0.2"/>
      <path d="M169.2 43.2324C169.025 43.2241 168.938 43.2166 168.601 42.8064C168.622 42.6009 168.802 42.4591 169.011 42.4696C169.074 42.4756 169.137 42.4824 169.2 42.4824C169.82 42.4824 170.325 41.9776 170.325 41.3574C170.325 40.7859 169.9 40.3051 169.336 40.2369C169.13 40.2129 168.983 40.0261 169.008 39.8199C169.033 39.6151 169.221 39.4629 169.425 39.4921C170.365 39.6046 171.075 40.4071 171.075 41.3566C171.075 42.3916 170.233 43.2324 169.2 43.2324Z" fill={color} stroke={color} strokeWidth="0.2"/>
      <path d="M154.966 43.2322C153.932 43.2322 153.091 42.3915 153.091 41.3572C153.091 40.3987 153.809 39.5962 154.76 39.492C154.971 39.474 155.15 39.618 155.174 39.8235C155.197 40.029 155.048 40.2142 154.842 40.2375C154.28 40.299 153.841 40.791 153.841 41.3572C153.841 41.9775 154.346 42.4822 154.966 42.4822C155.026 42.4822 155.082 42.477 155.13 42.4672C155.332 42.4207 155.531 42.5565 155.573 42.759C155.615 42.9622 155.483 43.1595 155.281 43.2015C155.183 43.2217 155.077 43.2322 154.966 43.2322Z" fill={color} stroke={color} strokeWidth="0.2"/>
      <path d="M159.091 42.4822C158.471 42.4822 157.966 41.9774 157.966 41.3572C157.966 40.7369 158.471 40.2322 159.091 40.2322C159.711 40.2322 160.216 40.7369 160.216 41.3572C160.216 41.9774 159.711 42.4822 159.091 42.4822ZM159.091 40.9822C158.884 40.9822 158.716 41.1509 158.716 41.3572C158.716 41.5634 158.884 41.7322 159.091 41.7322C159.298 41.7322 159.466 41.5634 159.466 41.3572C159.466 41.1509 159.298 40.9822 159.091 40.9822Z" fill={color} stroke={color} strokeWidth="0.2"/>
      <path d="M165.091 42.4822C164.471 42.4822 163.966 41.9774 163.966 41.3572C163.966 40.7369 164.471 40.2322 165.091 40.2322C165.711 40.2322 166.216 40.7369 166.216 41.3572C166.216 41.9774 165.711 42.4822 165.091 42.4822ZM165.091 40.9822C164.884 40.9822 164.716 41.1509 164.716 41.3572C164.716 41.5634 164.884 41.7322 165.091 41.7322C165.298 41.7322 165.466 41.5634 165.466 41.3572C165.466 41.1509 165.298 40.9822 165.091 40.9822Z" fill={color} stroke={color} strokeWidth="0.2"/>
      <path d="M162.091 45.4994C161.323 45.4994 160.554 45.2069 159.969 44.6219C159.823 44.4756 159.823 44.2379 159.969 44.0916C160.115 43.9454 160.353 43.9454 160.499 44.0916C161.377 44.9691 162.804 44.9691 163.682 44.0916C163.828 43.9454 164.066 43.9454 164.212 44.0916C164.358 44.2379 164.358 44.4756 164.212 44.6219C163.628 45.2076 162.859 45.4994 162.091 45.4994Z" fill={color} stroke={color} strokeWidth="0.2"/>
    </svg>
  ),
  Animals: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 11C7 11 5 12.8 5 14.5C5 15.4 5.7 15.8 6.5 15.8C7 15.8 7.6 15.7 8.1 15.5C8.5 15.4 9 15.3 9 15.3C9 15.3 9.5 15.4 9.9 15.5C10.4 15.7 11 15.8 11.5 15.8C12.3 15.8 13 15.4 13 14.5C13 12.8 11 11 9 11Z" stroke={color} strokeWidth="1.3" strokeLinejoin="round"/>
      <ellipse cx="6.5" cy="7.5" rx="1.4" ry="1.8" stroke={color} strokeWidth="1.3"/>
      <ellipse cx="11.5" cy="7.5" rx="1.4" ry="1.8" stroke={color} strokeWidth="1.3"/>
      <ellipse cx="3.5" cy="10.5" rx="1.1" ry="1.5" stroke={color} strokeWidth="1.3"/>
      <ellipse cx="14.5" cy="10.5" rx="1.1" ry="1.5" stroke={color} strokeWidth="1.3"/>
    </svg>
  ),
  Disability: ({ color }) => (
    <svg width="18" height="18" viewBox="369.9 31.7 14.2 17.1" fill="none">
      <path d="M377.203 35.1075C378.123 35.1075 378.871 34.3587 378.871 33.4389C378.871 32.5191 378.123 31.7703 377.203 31.7703C376.283 31.7703 375.534 32.5191 375.534 33.4389C375.534 34.3587 376.281 35.1075 377.203 35.1075Z" fill={color}/>
      <path d="M374.198 36.175L373.248 37.4476L373.021 36.6916C372.798 35.9446 372.064 35.3596 371.349 35.3596H370.346C370.148 35.3596 369.986 35.5216 369.986 35.7196C369.986 35.9176 370.148 36.0796 370.346 36.0796H371.351C371.743 36.0796 372.202 36.4612 372.332 36.8968L372.712 38.164L372.577 38.3458C372.11 38.9704 372.11 39.9496 372.578 40.5742L373.225 41.431C371.995 42.106 371.219 43.3912 371.219 44.8222C371.219 46.957 372.956 48.6958 375.093 48.6958C377.228 48.6958 378.965 46.9588 378.965 44.8222C378.965 44.1112 378.765 43.4362 378.419 42.853H379.312L380.198 45.5638C379.508 45.7384 378.997 46.3612 378.997 47.1046C378.997 47.9812 379.712 48.6958 380.588 48.6958C381.341 48.6958 381.973 48.1684 382.136 47.4646H383.674C383.872 47.4646 384.034 47.3026 384.034 47.1046C384.034 46.9066 383.872 46.7446 383.674 46.7446H382.136C382.127 46.7032 382.117 46.6636 382.104 46.6222C382.309 46.5448 382.482 46.417 382.606 46.246C382.819 45.9526 382.869 45.5602 382.741 45.1696L381.555 41.53C381.314 40.792 380.518 40.216 379.742 40.216H377.442L377.948 37.8328C377.968 37.714 377.978 37.5916 377.978 37.4728C377.978 36.3082 377.03 35.3596 375.865 35.3596C375.214 35.3596 374.609 35.653 374.198 36.175ZM375.091 47.974C373.352 47.974 371.938 46.5592 371.938 44.8204C371.938 43.6198 372.605 42.5452 373.66 42.0106L374.162 42.6766C374.679 43.1986 375.466 43.1986 375.95 42.7144C376.173 42.4912 376.292 42.205 376.308 41.9134C377.456 42.3976 378.241 43.5406 378.241 44.8204C378.245 46.5592 376.83 47.974 375.091 47.974ZM380.588 47.974C380.108 47.974 379.717 47.5834 379.717 47.1028C379.717 46.6222 380.108 46.2316 380.588 46.2316C381.069 46.2316 381.46 46.6222 381.46 47.1028C381.458 47.5834 381.067 47.974 380.588 47.974ZM375.865 36.0796C376.634 36.0796 377.258 36.7042 377.258 37.4728C377.258 37.552 377.251 37.633 377.24 37.6978L376.646 40.5004C376.623 40.6066 376.65 40.7182 376.718 40.801C376.787 40.8856 376.889 40.9342 376.997 40.9342H379.742C380.201 40.9342 380.727 41.3158 380.869 41.7514L382.055 45.391C382.111 45.562 382.1 45.715 382.023 45.8212C381.96 45.9094 381.85 45.9616 381.713 45.9778C381.508 45.7726 381.245 45.6232 380.954 45.5548L379.915 42.3778C379.867 42.2302 379.728 42.1294 379.573 42.1294H377.87C377.383 41.6236 376.756 41.251 376.049 41.0692C376.024 41.0386 375.998 41.008 375.971 40.9792L374.834 39.4564L376.153 37.6888C376.272 37.5304 376.24 37.3036 376.079 37.1848C375.919 37.066 375.694 37.0984 375.575 37.2568L374.094 39.2386C373.999 39.3664 373.999 39.541 374.094 39.6688L375.406 41.4256C375.644 41.6686 375.644 41.998 375.44 42.2014C375.242 42.3994 374.924 42.4048 374.72 42.2158L373.153 40.1422C372.881 39.7786 372.881 39.1396 373.153 38.776L374.771 36.6124C375.037 36.274 375.435 36.0796 375.865 36.0796Z" fill={color}/>
      <path d="M375.091 45.5799C375.489 45.5799 375.811 45.2575 375.811 44.8599C375.811 44.4622 375.489 44.1399 375.091 44.1399C374.693 44.1399 374.371 44.4622 374.371 44.8599C374.371 45.2575 374.693 45.5799 375.091 45.5799Z" fill={color}/>
    </svg>
  ),
  "Disaster Relief": ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 2L13.5 9H4.5L9 2Z" stroke={color} strokeWidth="1.3" strokeLinejoin="round"/>
      <path d="M9 5.5V7.5" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
      <circle cx="9" cy="8.5" r="0.5" fill={color}/>
      <path d="M2 13C3.5 11.5 4.5 12.5 6 11C7.5 9.5 8.5 11 10 11C11.5 11 12.5 9.5 14 11C15.5 12.5 15.5 11.5 16 13" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 16C3.5 14.5 4.5 15.5 6 14C7.5 12.5 8.5 14 10 14C11.5 14 12.5 12.5 14 14C15.5 15.5 15.5 14.5 16 16" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Education: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 3L17 7L9 11L1 7L9 3Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M5 9V13.5C5 13.5 6.5 15 9 15C11.5 15 13 13.5 13 13.5V9" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17 7V11" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  Elderly: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="3.5" r="2" stroke={color} strokeWidth="1.5"/>
      <path d="M6 7C6 7 5 8 5 10V14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M12 7C12 7 13 8 13 10V14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M6 10H12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M7 14L6.5 17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M11 14L11.5 17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M13 10C14 10 15 11 15 13V16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  Faith: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 15.5C9 15.5 2.5 11.5 2.5 7C2.5 4.515 4.515 2.5 7 2.5C8.105 2.5 9 3 9 3C9 3 9.895 2.5 11 2.5C13.485 2.5 15.5 4.515 15.5 7C15.5 11.5 9 15.5 9 15.5Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  ),
  Hunger: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M5 2V7C5 8.657 6.343 10 8 10H10C11.657 10 13 8.657 13 7V2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M9 10V16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M6 16H12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M9 2V5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  Medical: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <rect x="2.5" y="2.5" width="13" height="13" rx="2" stroke={color} strokeWidth="1.5"/>
      <path d="M9 5.5V12.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M5.5 9H12.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  DIY: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M3 15L7.5 10.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M12 3C10.5 3 9 4.5 9 6C9 7 9.5 7.7 9.5 7.7L3.5 13.7C3.2 14 3.2 14.5 3.5 14.8L3.7 15C4 15.3 4.5 15.3 4.8 15L10.8 9C10.8 9 11.5 9.5 12.5 9.5C14 9.5 15.5 8 15.5 6.5C15.5 6 15.4 5.6 15.2 5.2L13 7.4L11 5.4L13.2 3.2C12.8 3.1 12.4 3 12 3Z" stroke={color} strokeWidth="1.3" strokeLinejoin="round"/>
    </svg>
  ),
  Women: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="6.5" r="4" stroke={color} strokeWidth="1.5"/>
      <path d="M9 10.5V16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M6.5 13.5H11.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  Temples: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 1.2V2.4" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
      <path d="M9 2.6L5.4 6.6H12.6L9 2.6Z" stroke={color} strokeWidth="1.3" strokeLinejoin="round"/>
      <path d="M4.6 6.6H13.4V13.2H4.6V6.6Z" stroke={color} strokeWidth="1.3" strokeLinejoin="round"/>
      <path d="M8 13.2V10.8C8 10.2477 8.44772 9.8 9 9.8C9.55228 9.8 10 10.2477 10 10.8V13.2" stroke={color} strokeWidth="1.3" strokeLinejoin="round"/>
      <path d="M3.2 13.2H14.8" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
      <path d="M2.4 15.4H15.6" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  ),
  Community: ({ color }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="5.2" r="2.2" stroke={color} strokeWidth="1.3"/>
      <path d="M5.4 14.4C5.4 12.4118 7.01177 10.8 9 10.8C10.9882 10.8 12.6 12.4118 12.6 14.4" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
      <circle cx="3.9" cy="7.3" r="1.6" stroke={color} strokeWidth="1.3"/>
      <path d="M1.2 13.6C1.2 11.9431 2.37452 10.6 3.82353 10.6" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
      <circle cx="14.1" cy="7.3" r="1.6" stroke={color} strokeWidth="1.3"/>
      <path d="M16.8 13.6C16.8 11.9431 15.6255 10.6 14.1765 10.6" stroke={color} strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  ),
};

const DEFAULT_CATEGORY_NAMES = [
  "Urgent",
  "Children",
  "Animals",
  "Disability",
  "Disaster Relief",
  "Education",
  "Elderly",
  "Faith",
  "Hunger",
  "Medical",
  "DIY",
  "Women",
  "Temples",
  "Community",
];

const buildFallbackCategories = () =>
  DEFAULT_CATEGORY_NAMES.map((name, index) => ({ id: index + 1, name }));

const CategoriesCampaigns = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const home = useSelector((state) => state.cms.home);
  const [campaigns, setCampaigns] = useState([]);
  const [sectionLimit, setSectionLimit] = useState(6);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("Urgent");

  const cmsTitle = useMemo(() => {
    const sections = Array.isArray(home?.data) ? home.data : [];
    const section = sections.find((s) => s?.id === 62);
    return section?.title || "Behind every category lies a different story of suffering.";
  }, [home]);

  const categories = useMemo(() => buildFallbackCategories(), []);

  useEffect(() => {
    let isMounted = true;
    const fetchCampaigns = async () => {
      try {
        setLoading(true);
        const response = await getCategorySection(selectedCategory);
        if (isMounted) {
          setCampaigns(response?.data || []);
          setSectionLimit(response?.limit ?? 6);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          console.error("Error fetching category campaigns:", err);
          setCampaigns([]);
          setError("Unable to load campaigns right now.");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchCampaigns();
    return () => { isMounted = false; };
  }, [selectedCategory]);

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "40px", marginBottom: "15px" }}>
      <div
        style={{
          width: isMobile ? "calc(100% - 32px)" : "94.44%",
          maxWidth: "1368px",
          backgroundColor: "rgba(244, 241, 241, 0.36)",
          borderRadius: "20px",
          position: "relative",
          overflow: "visible",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: isMobile ? "26px 16px 32px" : "60px 32px 40px",
          boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
        }}
      >
        {/* Top-left sparkle decoration */}
        {!isMobile && (
          <img
            src={Images.orangeSparks}
            alt=""
            aria-hidden="true"
            style={{
              position: "absolute",
              top: "68px",
              left: "64px",
              width: "49.8429px",
              height: "71.2042px",
              pointerEvents: "none",
              zIndex: 1,
            }}
          />
        )}

        {/* Top-right heart decoration */}
        {!isMobile && (
          <img
            src={Images.heart}
            alt=""
            aria-hidden="true"
            style={{
              position: "absolute",
              top: "75px",
              right: "180px",
              width: "26.8898px",
              height: "28.1627px",
              pointerEvents: "none",
              zIndex: 1,
            }}
          />
        )}

        {/* Section heading */}
        <SectionHeader
          label="Categories"
          title={cmsTitle}
          sx={{ mb: "22px", pb: "10px", position: "relative", zIndex: 1 }}
        />

        {/* Tab bar */}
        <div
          style={{
            width: "100%",
            height: isMobile ? "60px" : "68px",
            backgroundColor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: "0px 10px 8px rgba(102, 102, 102, 0.1)",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            boxSizing: "border-box",
            marginBottom: "38px",
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              overflowX: "auto",
              width: "100%",
              gap: "6px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              scrollBehavior: "smooth",
            }}
          >
            {categories.map((category) => {
              const isSelected = selectedCategory === category.name;
              const IconComp = CategoryIcons[category.name];
              const iconColor = isSelected ? "#FFFFFF" : "#4A4A49";
              return (
                <div
                  key={category.id}
                  onClick={() => setSelectedCategory(category.name)}
                  style={{
                    backgroundColor: isSelected ? "#F04951" : "rgba(255,255,255,0.5)",
                    color: isSelected ? "#FFFFFF" : "#4A4A49",
                    padding: isMobile ? "10px 12px" : "10px 14px",
                    borderRadius: isSelected ? "10px" : "60px",
                    fontSize: isMobile ? "12px" : "14px",
                    fontFamily: "Red Hat Display, sans-serif",
                    fontWeight: 600,
                    lineHeight: isMobile ? "14px" : "16px",
                    letterSpacing: "-0.28px",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    flexShrink: 0,
                    userSelect: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  {IconComp && <IconComp color={iconColor} />}
                  {category.name}
                </div>
              );
            })}
          </div>
        </div>

        {/* Campaign cards */}
        <div
          style={{
            display: "flex",
            flexWrap: isMobile ? "nowrap" : "wrap",
            justifyContent: "flex-start",
            gap: isMobile ? "16px" : "18px",
            width: "100%",
            overflowX: isMobile ? "auto" : "visible",
            marginBottom: isMobile ? "24px" : "48px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            position: "relative",
            zIndex: 1,
          }}
        >
          {loading ? (
            Array.from({ length: isMobile ? 1 : sectionLimit }).map((_, i) => (
              <CampaignCardSkeleton key={`cat-skel-${i}`} />
            ))
          ) : campaigns.length ? (
            campaigns.map((campaign) => (
              <div key={campaign.id} style={{ marginBottom: "10px" }}>
                <CampaignCard campaignData={campaign} />
              </div>
            ))
          ) : (
            <div
              style={{
                width: "100%",
                padding: "40px 20px",
                textAlign: "center",
                color: "#666666",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              {error || "No campaigns available for this category."}
            </div>
          )}
        </div>

        {/* CTA button */}
        <div style={{ position: "relative", zIndex: 1 }}>
          <CampaignButtonVariant
            text="View All Campaigns"
            isMobile={isMobile}
            onClick={() => navigate("/campaigns")}
          />
        </div>
      </div>
    </div>
  );
};

export default CategoriesCampaigns;
